import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  paymentStatus: ["PAID", "UNPAID"],
  tableBgColorpayment: "#369dc9",
  paymentTabIndex: 0,
};

const paymentStatusSlice = createSlice({
  name: "tablePaidStatus",
  initialState,
  reducers: {
    setPaymentStatus: (state, action) => {
      if (action.payload === 1) {
        state.paymentStatus = "PAID";
        state.tableBgColorpayment = "#2bc155";
        state.paymentTabIndex = 1;
      } else if (action.payload === 2) {
        state.paymentStatus = "UNPAID";
        state.tableBgColorpayment = "#ffb800";
        state.paymentTabIndex = 2;
      } else if (action.payload === 3) {
        state.paymentStatus = "CANCELLED";
        state.tableBgColorpayment = "rgb(244, 107, 104)";
        state.paymentTabIndex = 3;
      } else {
        state.paymentStatus = ["PAID", "UNPAID"];
        state.tableBgColorpayment = "#369dc9";
        state.paymentTabIndex = 0;
      }
    },
  },
});

export const { setPaymentStatus } = paymentStatusSlice.actions;
export default paymentStatusSlice.reducer;
